import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute';

import OrganizationsGridLayout from './containers/Grid';

export default function OrganizationLayout() {
  return <Router>
    <PrivateRoute path="/admin/organizations" component={OrganizationsGridLayout} />
  </Router>;
}
